export default "__VITE_ASSET__CWCky_Pf__"